module.exports = __webpack_public_path__ + "img/494d814.jpg";